import { ActivatedRouteSnapshot } from '@angular/router';
import { ProjectSetup } from '@shared/models';
import { UserDetailsFacade } from '@shared/state/facades';
import { mergeMap, Observable, of } from 'rxjs';

export function canAccessTableOfColumns(
  userDetails: UserDetailsFacade,
  route: ActivatedRouteSnapshot
): Observable<boolean> {
  return userDetails.query.projectSetup$.pipe(
    mergeMap((projectSetup: ProjectSetup) => {
      return of(
        !!projectSetup?.tableOfColumns?.find(
          (x) => x.id === +route.params.tableOfColumnId
        )?.isActive
      );
    })
  );
}

export function canAccessFreeTextFields(
  userDetails: UserDetailsFacade,
  route: ActivatedRouteSnapshot
): Observable<boolean> {
  return userDetails.query.projectSetup$.pipe(
    mergeMap((projectSetup: ProjectSetup) => {
      return of(
        !!projectSetup?.freeTextFields?.find(
          (x) => x.id === +route.params.freeTextFieldId
        )?.isActive
      );
    })
  );
}
